export default {
  title: 'Activar reservas',
  buttons: {
    cancel: 'Cancelar',
    activate: 'Activar reservas',
  },
};
